import { Component, inject, Inject, OnInit } from '@angular/core';
import { AuthService } from '@app/services/auth.service';
import { ProjectsService } from '@app/services/old/projects.service';
import { UserService } from '@app/services/user.service';
import { provideCommonAngularModules } from '@app/share/provideAngularModules';
import { TranslatePipe } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-logout-modal',
  standalone: true,
  templateUrl: './logoutModal.component.html',
  styleUrls: ['./logoutModal.component.less'],
  imports: [TranslatePipe, NzButtonModule, ...provideCommonAngularModules()]
})
export class LogoutModalComponent implements OnInit {
  userService = inject(UserService);
  projectsService = inject(ProjectsService);
  nzModalRef = inject(NzModalRef);
  authService = inject(AuthService);
  myAvailabilityCount: number = 0;
  isLoading: boolean = false;

  ngOnInit(): void {
    this.getProjects()
  }

  getProjects() {
    this.projectsService.getProjects().subscribe((projects: any) => {
      if (projects) {
        let countOfcurrentUserAvailabilityInProjects = 0
        projects.forEach((project: any) => {
          if (project.user_available === true) {
            countOfcurrentUserAvailabilityInProjects += 1;
          }
        });
        this.myAvailabilityCount = countOfcurrentUserAvailabilityInProjects;
      }
    });
  }


  cancel() {
    this.nzModalRef.close();
  }

  async logout() {
    this.isLoading = true;
    const result = await this.authService.logout();
    this.isLoading = false;
    result && this.nzModalRef.close(true);
  }

}
